import React, { Component } from 'react';
import { cloneDeep } from 'lodash';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import axios from 'axios';
import TitleValidationModal from '../crosstab/FunctionBox/TitleValidationModal';
import rowsIcon from '../../images/rows-icon_1.png';
import columnsIcon from '../../images/columns-icon_1.png';
import basesIcon from '../../images/bases-icon_1.png';
import * as urls from '../../actions/urlTypes';
import { GEOGRAPHY_BASES } from '../../actions/actionTypes';
import {
  ADD_DICTIONARY_BOX_COLUMN,
  ADD_DICTIONARY_BOX_ROW,
  ADD_DICTIONARY_BOX_BASE,
  CODING_BOX_VERIFY_CLICK,
  CODING_BOX_DEFINE_CLICK,
  CODING_BOX_CLEAR_CLICK,
  CODING_BOX_SAVE_CLICK,
  CODING_BOX_AUTO_FORMAT_SELECT,
  CODING_BOX_AUTO_FORMAT_DESELECT,
  CODING_BOX_OR_OPERATOR_CLICK,
  CODING_BOX_AND_OPERATOR_CLICK,
  CODING_BOX_NOT_OPERATOR_CLICK,
  CODING_BOX_XOR_OPERATOR_CLICK,
  CODING_BOX_OPEN_PARANTHESIS_CLICK,
  CODING_BOX_CLOSING_PARANTHESIS_CLICK,
  FLEX_STUDY_TAG,
  AUTOCODE_ACCESS_ID,
} from '../../constants';
import ExpressionCodingBox from '../common/ExpressionCodingBox';
import GenericButton from '../common/GenericButton';
import ExpressionCreatorBtnDropdown from '../common/ExpressionCreatorBtnDropdown';
import Modal from '../common/Modal/Modal';
import AddToDefinition from '../common/AddToDefinition';
import { isAllFeaturePresent } from '../../util/CommonUtils';
import {
  divideJointExpressions,
  buildAutoCodeObject,
  buildFunctionNode,
  mergeGeographyNodes,
  buildAutocodenodeWithNot,
  buildACStructureNode,
} from '../../util/autocodeUtils';
import {
  getExpressionFormed,
  getObjectAdded,
  checkKeywords,
  functionsInComposer,
  specialCharList,
} from '../autocode/AutocodeFunctions';
import { getDicForDefKeywords } from '../../actions/autocodeActions';
import { AC_OPERATORS } from '../autocode/AutocodeConstants';

const TitleValidationModalStyle = {
  width: '24%',
  height: 'auto',
  left: '35%',
  top: '30%',
};
const defineModalStyle = {
  width: '43%',
  height: '250px',
  left: '25%',
  top: '30%',
};

const addAfterRunCrosstabModalStyle = {
  width: '20%',
  height: 'auto',
  left: '35%',
  top: '20%',
};

class ExpressionCreatorV2 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isAutoFormatEnabled: false,
      boxTitle: '',
      userText: '',
      definedExpression: '',
      isExpValid: false,
      isVerifiable: false,
      titleChanged: false,
    };
  }

  UNSAFE_componentWillMount() {
    if (this.props.allFeatures) {
      this.setState({
        isAutocodePresent: isAllFeaturePresent(
          AUTOCODE_ACCESS_ID,
          this.props.allFeatures
        ),
      });
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.moduleStudy !== nextProps.moduleStudy) {
      this.handleverify();
    }
    if (
      nextProps.refreshFlag &&
      this.props.refreshFlag !== nextProps.refreshFlag
    ) {
      this.handleClearBox();
    }
  }

  handleSelectedKeywords = (
    selectedKeywordNodes,
    titlePrefix,
    selectedOperator
  ) =>
    this.expCB
      .getDecoratedComponentInstance()
      .handleSelectedKeywords(
        selectedKeywordNodes,
        titlePrefix,
        selectedOperator
      );

  handleClearBox = () => {
    this.props.trackerFn({ action: CODING_BOX_CLEAR_CLICK });
    this.setState({ boxTitle: '', userText: '', titleChanged: false });
    this.expCB.getDecoratedComponentInstance().handleClearBox();
  };

  moveAppendToCodingBox = (
    isMove,
    expressionKeyword,
    functionTitle,
    smartSearchArray
  ) => {
    this.setState({ boxTitle: functionTitle });
    this.expCB
      .getDecoratedComponentInstance()
      .moveAppendToCodingBox(
        isMove,
        expressionKeyword,
        functionTitle,
        smartSearchArray
      );
  };

  handleBoxtitle = event =>
    this.setState({
      boxTitle: event.target.value,
      userText: event.target.value,
      titleChanged: true,
    });

  toggleLabelUpdate = () => this.setState({ titleChanged: true });

  handleverify = () => {
    this.props.trackerFn({ action: CODING_BOX_VERIFY_CLICK });
    if (this.props.moduleStudy) {
      this.expCB
        .getDecoratedComponentInstance()
        .validateContent(false, undefined, true, {
          token: this.props.loginResponse.data.token,
          activeAccountId: this.props.activeAccountId,
          uid: this.props.loginResponse.data.uid,
          productNo: this.props.moduleStudy.pn,
        });
    }
  };

  handleDefine = () => {
    this.props.trackerFn({ action: CODING_BOX_DEFINE_CLICK });
    const expressionKeyword = this.expCB
      .getDecoratedComponentInstance()
      .getExpressionState();
    const contentExtractor = document.createElement('div');
    contentExtractor.innerHTML = expressionKeyword.html;
    const extractedContents = (
      contentExtractor.textContent || contentExtractor.innerText
    ).replace(/\s+/g, ' ');
    const url = `${urls.ROOT_URL}/dictionary/define`;
    if (extractedContents) {
      axios({
        url,
        method: 'post',
        headers: {
          Authorization: `Bearer ${this.props.loginResponse.data.token}`,
        },
        data: {
          uid: `${this.props.loginResponse.data.uid}`,
          accountId: `${this.props.activeAccountId}`,
          productNo: `${this.props.moduleStudy.pn}`,
          expression: extractedContents,
        },
        withCredentials: true,
        responseType: 'json',
      })
        .then(response => {
          this.setState({ definedExpression: response.data.message }, () =>
            this.defineExpressionModal.show()
          );
        })
        .catch(response => console.warn(response.data));
    }
  };

  handleCrosstabEditToDictionary = (idKey, dataSmartSearch, keyword) => {
    this.expCB
      .getDecoratedComponentInstance()
      .handleCrosstabEditToDictionary(idKey, dataSmartSearch, keyword);
  };

  handleProbabilitiesEditClick = (rowData, colData) => {
    this.expCB
      .getDecoratedComponentInstance()
      .handleProbabilitiesEditClick(rowData, colData);
  };

  handleUserDefinedText = userDefinedText => {
    this.setState({
      userText: userDefinedText,
      boxTitle: userDefinedText,
      titleChanged: true,
    });
  };

  handleSmartSearchArray = (
    objSmartSearchArray,
    objArray,
    isLabelUpdated,
    labelOverride,
    finalObjectsAdded
  ) => {
    const newObjectSmartSearchArr = cloneDeep(objSmartSearchArray);

    if (this.state.isAutocodePresent && finalObjectsAdded !== undefined) {
      const objAdded = cloneDeep(finalObjectsAdded);

      for (let i = 0; i < objAdded.length - 1; i += 1) {
        if (
          objAdded[i].keyword === AC_OPERATORS.type.and.label &&
          objAdded[i + 1].keyword === AC_OPERATORS.type.not.label
        ) {
          objAdded.splice(i, 2, {
            node: '',
            recType: ' ',
            keyword: AC_OPERATORS.type.andnot.label,
            shortText: AC_OPERATORS.type.andnot.label,
            shortTextCatgView: AC_OPERATORS.type.andnot.label,
            objectType: 'operator',
          });
        } else if (
          objAdded[i].keyword === AC_OPERATORS.type.or.label &&
          objAdded[i + 1].keyword === AC_OPERATORS.type.not.label
        ) {
          objAdded.splice(i, 2, {
            node: '',
            recType: ' ',
            keyword: AC_OPERATORS.type.ornot.label,
            shortText: AC_OPERATORS.type.ornot.label,
            shortTextCatgView: AC_OPERATORS.type.ornot.label,
            objectType: 'operator',
          });
        }
      }

      const expressionFormed = objAdded.map(items => {
        return items.keyword;
      });
      newObjectSmartSearchArr.autocodenode = buildAutoCodeObject(
        expressionFormed,
        objAdded,
        isLabelUpdated,
        labelOverride
      );
    }
    newObjectSmartSearchArr.objectsAdded = objArray;
    return newObjectSmartSearchArr;
  };

  checkAutocodeNode = (
    dictionaryDetails,
    expression,
    objSmartSearchArray,
    isLabelUpdated,
    label
  ) => {
    let acnode = {};
    const expArr = getExpressionFormed(expression);
    const operatorArr = ['AND', 'OR', 'NOT', 'XOR', 'OR NOT', 'AND NOT'];
    const isFunctionitem =
      expArr.some(item => functionsInComposer.includes(item.toUpperCase())) ||
      expArr.includes('+');
    const isOperatoritem = expArr.some(
      item => item !== '(' && item !== ')' && operatorArr.includes(item)
    );
    const isNetAny = isOperatoritem
      ? expArr
          .filter(item => checkKeywords(item))
          .every(item => item.startsWith('XNA'))
      : false;

    const containsGeoNode = expArr.some(item => GEOGRAPHY_BASES.includes(item));

    const containsNotFunction = expArr.some(
      item => item === AC_OPERATORS.type.not.label
    );

    if (isFunctionitem || isNetAny) {
      const expressionFormed = expArr.filter(item => checkKeywords(item));
      const objectsAdded = getObjectAdded(expressionFormed, dictionaryDetails);

      acnode = buildFunctionNode(
        dictionaryDetails,
        expression,
        expressionFormed,
        objectsAdded,
        [true],
        label,
        false
      );
    } else {
      let expressionFormed;
      const objectsAdded = [];

      if (containsGeoNode) {
        expressionFormed = mergeGeographyNodes(expArr);
        objectsAdded.push(
          ...getObjectAdded(expressionFormed, dictionaryDetails)
        );
        acnode = buildAutoCodeObject(
          expressionFormed,
          objectsAdded,
          dictionaryDetails,
          isLabelUpdated,
          label
        );
      } else if (containsNotFunction) {
        expressionFormed = cloneDeep(expArr);
        objectsAdded.push(...getObjectAdded(expArr, dictionaryDetails));

        acnode = buildAutocodenodeWithNot(expArr, dictionaryDetails, label);
      } else {
        expressionFormed = expArr.filter(item => checkKeywords(item));
        const containsSpecialChars = expArr.some(elem =>
          specialCharList.includes(elem)
        );
        if (containsSpecialChars) {
          objectsAdded.push(
            ...getObjectAdded(expressionFormed, dictionaryDetails)
          );
          acnode = buildACStructureNode([], label);
        } else {
          objectsAdded.push(...getObjectAdded(expArr, dictionaryDetails));
          acnode = buildAutoCodeObject(
            expArr,
            objectsAdded,
            dictionaryDetails,
            isLabelUpdated,
            isLabelUpdated ? label : ''
          );
        }
      }
      if (isLabelUpdated && label.trim().length > 0) {
        acnode.useLabelOverride = true;
        acnode.labelOverride = label;
      }
    }

    return acnode;
  };

  moveToScratch = () => {
    const expressionKeyword = this.expCB
      .getDecoratedComponentInstance()
      .getExpressionState();
    const contentExtractor = document.createElement('div');
    contentExtractor.innerHTML = expressionKeyword.html;
    const extractedContents = (
      contentExtractor.textContent || contentExtractor.innerText
    ).replace(/\s+/g, ' ');

    if (this.state.boxTitle && extractedContents) {
      const sampleWeightedParams = {
        targetGrid: 'ScratchDataGrid',
        token: this.props.loginResponse.data.token,
        uid: this.props.loginResponse.data.uid,
        accountId: this.props.activeAccountId,
        productNo: this.props.moduleStudy.pn,
        weightType: this.props.moduleWeigthType.wt,
        divisor: this.props.moduleWeigthType.dv,
        gridData: this.props.gridData.ScratchDataGrid,
        expressionList: [extractedContents],
        selectedNames: [this.state.boxTitle],
        sourceGrid: 'ExpressionCodingBox',
        userDefinedText: this.state.userText.trim().length > 0,
        isLabelUpdated: [this.state.titleChanged],
      };
      if (this.props.breadcrumbFlag) {
        sampleWeightedParams.objSmartSearchArray = [
          this.handleSmartSearchArray(
            expressionKeyword.objSmartSearchArray,
            expressionKeyword.objArray,
            this.state.titleChanged,
            this.state.userText.trim(),
            expressionKeyword.finalObjectsAdded
          ),
        ];
      }
      this.props.getSampleWeighted(sampleWeightedParams);
      this.handleClearBox();
    } else {
      this.boxTitleValidationModal.show();
    }
  };

  moveToBases = () => {
    this.props.trackerFn({
      action: ADD_DICTIONARY_BOX_BASE,
      attributes: { expression: this.state.boxTitle },
    });
    const expressionKeyword = this.expCB
      .getDecoratedComponentInstance()
      .getExpressionState();
    const contentExtractor = document.createElement('div');
    contentExtractor.innerHTML = expressionKeyword.html;
    const extractedContents = (
      contentExtractor.textContent || contentExtractor.innerText
    ).replace(/\s+/g, ' ');
    let isBaseAllowed = false;
    let rectype = 'B';

    if (!this.props.moduleStudy.st.toLowerCase().includes(FLEX_STUDY_TAG)) {
      isBaseAllowed = true;
    } else if (this.props.gridData.BasesDataGrid.length > 0) {
      isBaseAllowed = false;
    } else {
      const geographyBase = GEOGRAPHY_BASES.some(base =>
        extractedContents.includes(base)
      );
      if (geographyBase) {
        rectype = 'L';
        isBaseAllowed = true;
      } else {
        isBaseAllowed = false;
      }
    }
    if (isBaseAllowed) {
      if (this.state.boxTitle && extractedContents) {
        const sampleWeightedParams = {
          targetGrid: 'BasesDataGrid',
          token: this.props.loginResponse.data.token,
          uid: this.props.loginResponse.data.uid,
          accountId: this.props.activeAccountId,
          productNo: this.props.moduleStudy.pn,
          weightType: this.props.moduleWeigthType.wt,
          divisor: this.props.moduleWeigthType.dv,
          gridData: this.props.gridData.BasesDataGrid,
          expressionList: [extractedContents],
          selectedNames: [this.state.boxTitle],
          sourceGrid: 'ExpressionCodingBox',
          recTypes: [rectype],
          userDefinedText: this.state.userText.trim().length > 0,
          isLabelUpdated: [this.state.titleChanged],
        };
        if (this.props.breadcrumbFlag) {
          sampleWeightedParams.objSmartSearchArray = [
            this.handleSmartSearchArray(
              expressionKeyword.objSmartSearchArray,
              expressionKeyword.objArray,
              this.state.titleChanged,
              this.state.userText.trim(),
              expressionKeyword.finalObjectsAdded
            ),
          ];
        }

        const expressionList = divideJointExpressions([extractedContents]);

        getDicForDefKeywords(
          this.props.loginResponse.data.uid,
          this.props.activeAccountId,
          this.props.moduleStudy.pn,
          expressionList
        ).then(response => {
          sampleWeightedParams.objSmartSearchArray[0].autocodenode = this.checkAutocodeNode(
            response,
            extractedContents.trim(),
            sampleWeightedParams.objSmartSearchArray[0],
            this.state.titleChanged,
            this.state.boxTitle
          );

          this.props.getSampleWeighted(sampleWeightedParams);
          this.handleClearBox();
        });
      } else {
        this.boxTitleValidationModal.show();
      }
    } else {
      this.addAfterRunCrosstabModal.show();
    }
  };

  moveToRows = () => {
    this.props.trackerFn({
      action: ADD_DICTIONARY_BOX_ROW,
      attributes: { expression: this.state.boxTitle },
    });
    const expressionKeyword = this.expCB
      .getDecoratedComponentInstance()
      .getExpressionState();
    const contentExtractor = document.createElement('div');
    contentExtractor.innerHTML = expressionKeyword.html;
    const extractedContents = (
      contentExtractor.textContent || contentExtractor.innerText
    ).replace(/\s+/g, ' ');

    const geographyBase = GEOGRAPHY_BASES.some(base =>
      extractedContents.includes(base)
    );
    let rectype = 'B';
    if (geographyBase) {
      rectype = 'L';
    }

    if (this.state.boxTitle && extractedContents) {
      const sampleWeightedParams = {
        targetGrid: 'RowsDataGrid',
        token: this.props.loginResponse.data.token,
        uid: this.props.loginResponse.data.uid,
        accountId: this.props.activeAccountId,
        productNo: this.props.moduleStudy.pn,
        weightType: this.props.moduleWeigthType.wt,
        divisor: this.props.moduleWeigthType.dv,
        expressionList: [extractedContents],
        gridData: this.props.gridData.RowsDataGrid,
        selectedNames: [this.state.boxTitle],
        sourceGrid: 'ExpressionCodingBox',
        recTypes: [rectype],
        userDefinedText: this.state.userText.trim().length > 0,
        isLabelUpdated: [this.state.titleChanged],
      };
      if (this.props.breadcrumbFlag) {
        sampleWeightedParams.objSmartSearchArray = [
          this.handleSmartSearchArray(
            expressionKeyword.objSmartSearchArray,
            expressionKeyword.objArray,
            this.state.titleChanged,
            this.state.userText.trim(),
            expressionKeyword.finalObjectsAdded
          ),
        ];
      }

      const expressionList = divideJointExpressions([extractedContents]);

      getDicForDefKeywords(
        this.props.loginResponse.data.uid,
        this.props.activeAccountId,
        this.props.moduleStudy.pn,
        expressionList
      ).then(response => {
        sampleWeightedParams.objSmartSearchArray[0].autocodenode = this.checkAutocodeNode(
          response,
          extractedContents.trim(),
          sampleWeightedParams.objSmartSearchArray[0],
          this.state.titleChanged,
          this.state.boxTitle
        );

        this.props.getSampleWeighted(sampleWeightedParams);
        this.handleClearBox();
      });
    } else {
      this.boxTitleValidationModal.show();
    }
  };

  moveToColumns = () => {
    this.props.trackerFn({
      action: ADD_DICTIONARY_BOX_COLUMN,
      attributes: { expression: this.state.boxTitle },
    });
    const expressionKeyword = this.expCB
      .getDecoratedComponentInstance()
      .getExpressionState();
    const contentExtractor = document.createElement('div');
    contentExtractor.innerHTML = expressionKeyword.html;
    const extractedContents = (
      contentExtractor.textContent || contentExtractor.innerText
    ).replace(/\s+/g, ' ');

    const geographyBase = GEOGRAPHY_BASES.some(base =>
      extractedContents.includes(base)
    );
    let rectype = 'B';
    if (geographyBase) {
      rectype = 'L';
    }

    if (this.state.boxTitle && extractedContents) {
      const sampleWeightedParams = {
        targetGrid: 'ColumnsDataGrid',
        token: this.props.loginResponse.data.token,
        uid: this.props.loginResponse.data.uid,
        accountId: this.props.activeAccountId,
        productNo: this.props.moduleStudy.pn,
        weightType: this.props.moduleWeigthType.wt,
        divisor: this.props.moduleWeigthType.dv,
        expressionList: [extractedContents],
        gridData: this.props.gridData.ColumnsDataGrid,
        selectedNames: [this.state.boxTitle],
        sourceGrid: 'ExpressionCodingBox',
        recTypes: [rectype],
        userDefinedText: this.state.userText.trim().length > 0,
        isLabelUpdated: [this.state.titleChanged],
      };
      if (this.props.breadcrumbFlag) {
        sampleWeightedParams.objSmartSearchArray = [
          this.handleSmartSearchArray(
            expressionKeyword.objSmartSearchArray,
            expressionKeyword.objArray,
            this.state.titleChanged,
            this.state.userText.trim(),
            expressionKeyword.finalObjectsAdded
          ),
        ];
      }

      const expressionList = divideJointExpressions([extractedContents]);

      getDicForDefKeywords(
        this.props.loginResponse.data.uid,
        this.props.activeAccountId,
        this.props.moduleStudy.pn,
        expressionList
      ).then(response => {
        sampleWeightedParams.objSmartSearchArray[0].autocodenode = this.checkAutocodeNode(
          response,
          extractedContents.trim(),
          sampleWeightedParams.objSmartSearchArray[0],
          this.state.titleChanged,
          this.state.boxTitle
        );

        this.props.getSampleWeighted(sampleWeightedParams);
        this.handleClearBox();
      });
    } else {
      this.boxTitleValidationModal.show();
    }
  };

  genericMoveTo = targetGrid => {
    const expressionKeyword = this.expCB
      .getDecoratedComponentInstance()
      .getExpressionState();
    const contentExtractor = document.createElement('div');
    contentExtractor.innerHTML = expressionKeyword.html;
    const extractedContents = (
      contentExtractor.textContent || contentExtractor.innerText
    ).replace(/\s+/g, ' ');
    const geographyBase = GEOGRAPHY_BASES.some(base =>
      extractedContents.includes(base)
    );
    let rectype = 'B';
    if (geographyBase) {
      rectype = 'L';
    }
    if (this.state.boxTitle && extractedContents) {
      const sampleWeightedParams = {
        targetGrid,
        token: this.props.loginResponse.data.token,
        uid: this.props.loginResponse.data.uid,
        accountId: this.props.activeAccountId,
        productNo: this.props.moduleStudy.pn,
        weightType: this.props.moduleWeigthType.wt,
        divisor: this.props.moduleWeigthType.dv,
        gridData: [],
        expressionList: [extractedContents],
        selectedNames: [this.state.boxTitle],
        sourceGrid: 'ExpressionCodingBox',
        recTypes: [rectype],
        userDefinedText: this.state.userText.trim().length > 0,
        isLabelUpdated: [this.state.titleChanged],
      };
      if (this.props.breadcrumbFlag) {
        sampleWeightedParams.objSmartSearchArray = [
          this.handleSmartSearchArray(
            expressionKeyword.objSmartSearchArray,
            expressionKeyword.objArray,
            this.state.titleChanged,
            this.state.userText.trim(),
            expressionKeyword.finalObjectsAdded
          ),
        ];
      }
      this.props.getSampleWeighted(sampleWeightedParams);
      this.handleClearBox();
    } else {
      this.boxTitleValidationModal.show();
    }
  };

  localHandleAutoformat = e => {
    if (e.target.checked) {
      this.props.trackerFn({ action: CODING_BOX_AUTO_FORMAT_SELECT });
    } else {
      this.props.trackerFn({ action: CODING_BOX_AUTO_FORMAT_DESELECT });
    }
    this.setState(
      { isAutoFormatEnabled: !this.state.isAutoFormatEnabled },
      () =>
        this.expCB
          .getDecoratedComponentInstance()
          .handleAutoformat(this.state.isAutoFormatEnabled)
    );
  };

  addToDefinition = () => {
    this.props.trackerFn({ action: CODING_BOX_SAVE_CLICK });
    const expressionKeyword = this.expCB
      .getDecoratedComponentInstance()
      .getExpressionState();
    const contentExtractor = document.createElement('div');
    contentExtractor.innerHTML = expressionKeyword.html;
    const extractedContents = (
      contentExtractor.textContent || contentExtractor.innerText
    ).replace(/\s+/g, ' ');
    this.setState({
      addToDefinition: [
        { id: 0, name: this.state.boxTitle, expression: extractedContents },
      ],
    });
    if (this.state.boxTitle && extractedContents) {
      this.addToDefinitionModal.show();
    } else {
      this.boxTitleValidationModal.show();
    }
  };

  render() {
    return (
      <div className="expression-creator-wrapper">
        <div className="expression-creator">
          <div className="row expanded">
            <div className="small-5 columns end padding-left-0 padding-right-0">
              <label htmlFor="name-input" className="show-for-sr">
                Name:{' '}
              </label>
              <input
                type="text"
                id="name-input"
                placeholder="Enter Name"
                className="coding-name"
                value={this.state.boxTitle}
                onChange={this.handleBoxtitle}
              />
            </div>
            <div className="button-group small-7 columns padding-left-0 padding-right-0">
              <ul className="shown-operators text-right">
                <li>
                  <GenericButton
                    name="OR"
                    btnStyle="button operator-button"
                    onBtnClick={() => {
                      this.props.trackerFn({
                        action: CODING_BOX_OR_OPERATOR_CLICK,
                      });
                      this.expCB
                        .getDecoratedComponentInstance()
                        .handleOperator('OR');
                    }}
                  />
                  {/* <span>&#124;</span> */}
                </li>
                <li>
                  <GenericButton
                    name="AND"
                    btnStyle="button operator-button"
                    onBtnClick={() => {
                      this.props.trackerFn({
                        action: CODING_BOX_AND_OPERATOR_CLICK,
                      });
                      this.expCB
                        .getDecoratedComponentInstance()
                        .handleOperator('AND');
                    }}
                  />
                  {/* <span>&#124;</span> */}
                </li>
                <li>
                  <GenericButton
                    name="NOT"
                    btnStyle="button operator-button"
                    onBtnClick={() => {
                      this.props.trackerFn({
                        action: CODING_BOX_NOT_OPERATOR_CLICK,
                      });
                      this.expCB
                        .getDecoratedComponentInstance()
                        .handleOperator('NOT');
                    }}
                  />
                  {/* <span>&#124;</span> */}
                </li>
                <li>
                  <GenericButton
                    name="XOR"
                    btnStyle="button operator-button"
                    onBtnClick={() => {
                      this.props.trackerFn({
                        action: CODING_BOX_XOR_OPERATOR_CLICK,
                      });
                      this.expCB
                        .getDecoratedComponentInstance()
                        .handleOperator('XOR');
                    }}
                  />
                  {/* <span>&#124;</span> */}
                </li>
                <li>
                  <GenericButton
                    name="("
                    btnStyle="button operator-button"
                    onBtnClick={() => {
                      this.props.trackerFn({
                        action: CODING_BOX_OPEN_PARANTHESIS_CLICK,
                      });
                      this.expCB
                        .getDecoratedComponentInstance()
                        .handleOperator('(');
                    }}
                  />
                  {/* <span>&#124;</span> */}
                </li>
                <li>
                  <GenericButton
                    name=")"
                    btnStyle="button operator-button"
                    onBtnClick={() => {
                      this.props.trackerFn({
                        action: CODING_BOX_CLOSING_PARANTHESIS_CLICK,
                      });
                      this.expCB
                        .getDecoratedComponentInstance()
                        .handleOperator(')');
                    }}
                  />
                </li>
                <li>
                  <ExpressionCreatorBtnDropdown
                    dropDownText="ADVANCED"
                    dropdownOptions={[
                      {
                        name: '+',
                        onDropDownOptionClick: () =>
                          this.expCB
                            .getDecoratedComponentInstance()
                            .handleOperator('+'),
                      },
                      {
                        name: '-',
                        onDropDownOptionClick: () =>
                          this.expCB
                            .getDecoratedComponentInstance()
                            .handleOperator('-'),
                      },
                      {
                        name: String.fromCharCode(215),
                        onDropDownOptionClick: () =>
                          this.expCB
                            .getDecoratedComponentInstance()
                            .handleOperator('*'),
                      },
                      {
                        name: String.fromCharCode(247),
                        onDropDownOptionClick: () =>
                          this.expCB
                            .getDecoratedComponentInstance()
                            .handleOperator('/'),
                      },
                    ]}
                    trackerFn={this.props.trackerFn}
                  />
                </li>
              </ul>
            </div>
          </div>

          <div className="row expanded">
            <div className="small-12 large-12 columns end padding-left-0 padding-right-0">
              <ExpressionCodingBox
                ref={node => (this.expCB = node)}
                boxTitle={this.state.boxTitle}
                moduleStudy={this.props.moduleStudy}
                handleUserDefinedText={this.handleUserDefinedText}
                toggleLabelUpdate={this.toggleLabelUpdate}
                handleValidation={(isExpValid, boxTitle, isVerifiable) =>
                  this.setState({
                    isExpValid,
                    boxTitle:
                      this.state.userText.trim().length > 0
                        ? this.state.userText
                        : boxTitle,
                    isVerifiable,
                  })
                }
              />
            </div>
          </div>

          <div className="row expanded">
            <div className="button-group small-12 columns end padding-left-0 padding-right-0 margin-top-10">
              {/** commented below code as part of dictionary search refactoring because
               * this code is not being used anywhere */}
              {/* <div
                className={
                  this.props.selectedModule === 'Crosstab' ? 'hidden' : ''
                }
              >
                <GenericButton
                  name="Move to Base"
                  btnStyle="button btn-coding-box-options"
                  onBtnClick={() => this.genericMoveTo('BaseDataGrid')}
                  {...(!this.state.isExpValid || this.state.boxTitle === ''
                    ? { btnDisabled: true }
                    : {})}
                />
                <GenericButton
                  name="Move to Target"
                  btnStyle="button btn-coding-box-options"
                  onBtnClick={() => this.genericMoveTo('TargetDataGrid')}
                  {...(!this.state.isExpValid || this.state.boxTitle === ''
                    ? { btnDisabled: true }
                    : {})}
                />
              </div> */}
            </div>
            <div className="small-3 columns padding-left-0 autoformat-checkbox">
              <input
                id="autoformat-checkbox"
                type="checkbox"
                checked={this.state.isAutoFormatEnabled}
                onChange={event => this.localHandleAutoformat(event)}
              />
              <label htmlFor="autoformat-checkbox">Auto Format</label>
            </div>
            <div className="small-9 columns end padding-left-0 padding-right-0">
              <div className="button-group float-right margin-bottom-o">
                <GenericButton
                  name="Verify"
                  btnStyle="button btn-coding-box-options"
                  onBtnClick={() => this.handleverify()}
                  // {...(!this.state.isVerifiable ? { btnDisabled: true } : {})}
                />
                <GenericButton
                  name="Define"
                  btnStyle="button btn-coding-box-options"
                  onBtnClick={() => this.handleDefine()}
                  {...(!this.state.isExpValid ? { btnDisabled: true } : {})}
                />
                <GenericButton
                  name="Clear"
                  btnStyle="button btn-coding-box-options"
                  onBtnClick={() => this.handleClearBox()}
                />
                {!this.props.noDefinitionsFlag && (
                  <GenericButton
                    name="Save"
                    btnStyle="button btn-coding-box-options"
                    onBtnClick={() => this.addToDefinition()}
                    {...(!this.state.isExpValid ? { btnDisabled: true } : {})}
                  />
                )}
                <div
                  className="move-to-btn btn-coding-box-options"
                  style={{
                    display: this.props.noCRB ? 'none' : 'inline-block',
                  }}
                >
                  <div>
                    <button
                      type="button"
                      onClick={this.moveToColumns}
                      title="Move to Columns"
                      disabled={
                        !this.state.isExpValid || this.state.boxTitle === ''
                      }
                    >
                      <img
                        className="move-icon"
                        src={columnsIcon}
                        alt="Move to Columns"
                      />
                    </button>
                    <button
                      type="button"
                      onClick={this.moveToRows}
                      title="Move to Rows"
                      disabled={
                        !this.state.isExpValid || this.state.boxTitle === ''
                      }
                    >
                      <img
                        className="move-icon"
                        src={rowsIcon}
                        alt="Move to Rows"
                      />
                    </button>
                    <button
                      type="button"
                      onClick={this.moveToBases}
                      title="Move to Bases"
                      disabled={
                        !this.state.isExpValid || this.state.boxTitle === ''
                      }
                    >
                      <img
                        className="move-icon"
                        src={basesIcon}
                        alt="Move to Bases"
                      />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Modal
            title="Title Required"
            ref={node => (this.boxTitleValidationModal = node)}
            dialogStyles={TitleValidationModalStyle}
          >
            <div className="row expanded">
              <TitleValidationModal
                customMessage="You must enter proper expression to add to colums or rows"
                handleParentHide={() => this.boxTitleValidationModal.hide()}
              />
            </div>
          </Modal>
          <Modal
            title="Expression Definition"
            ref={node => (this.defineExpressionModal = node)}
            dialogStyles={defineModalStyle}
          >
            <div className="large-12 columns">
              <div className="column row">
                <TitleValidationModal
                  customMessage={this.state.definedExpression}
                  handleParentHide={() => this.defineExpressionModal.hide()}
                />
              </div>
            </div>
          </Modal>
          <Modal
            title="Add to Definition..."
            ref={node => (this.addToDefinitionModal = node)}
            dialogStyles={defineModalStyle}
          >
            <AddToDefinition
              folderName={this.state.boxTitle}
              newExpressions={this.state.addToDefinition}
              handleHide={() => this.addToDefinitionModal.hide()}
              srcScreen="QuestionsScreen"
              moduleStudy={this.props.moduleStudy}
            />
          </Modal>
          <Modal
            title="Run Crosstab"
            ref={node => (this.addAfterRunCrosstabModal = node)}
            dialogStyles={addAfterRunCrosstabModalStyle}
          >
            <p>Only one geography base can be added.</p>
            <GenericButton
              name="OK"
              btnStyle="button display-block margin-auto"
              onBtnClick={() => this.addAfterRunCrosstabModal.hide()}
            />
          </Modal>
        </div>
      </div>
    );
  }
}

ExpressionCreatorV2.propTypes = {
  selectedModule: PropTypes.string,
  gridData: PropTypes.shape({
    ColumnsDataGrid: PropTypes.arrayOf(PropTypes.object),
    RowsDataGrid: PropTypes.arrayOf(PropTypes.object),
    BasesDataGrid: PropTypes.arrayOf(PropTypes.object),
    ScratchDataGrid: PropTypes.arrayOf(PropTypes.object),
  }),
  loginResponse: PropTypes.shape({
    data: PropTypes.shape({
      uid: PropTypes.number,
      token: PropTypes.string,
    }),
  }),
  moduleStudy: PropTypes.shape({
    st: PropTypes.string,
    pn: PropTypes.number,
    dv: PropTypes.number,
    wt: PropTypes.number,
  }),
  getSampleWeighted: PropTypes.func,
  activeAccountId: PropTypes.number,
  trackerFn: PropTypes.func,
  moduleWeigthType: PropTypes.shape({
    dv: PropTypes.number,
    wt: PropTypes.number,
  }),
  noCRB: PropTypes.bool,
  noDefinitionsFlag: PropTypes.bool,
  breadcrumbFlag: PropTypes.bool,
  allFeatures: PropTypes.arrayOf(PropTypes.array),
};

function mapStateToProps(state) {
  return {
    loginResponse: state.login.loginResponse,
    activeAccountId: state.account.activeAccountId,
    allFeatures: state.userDetail.allFeatures,
  };
}

export default connect(mapStateToProps, null, null, { forwardRef: true })(
  ExpressionCreatorV2
);
